import { PAYMENT_STATUSES } from '@repo/api-contracts';
import { type ReactElement, useState } from 'react';
import { useNavigate } from 'react-router';
import {
  PAYMENT_STATUS_LABELS,
  type PaymentProviderFilter,
  type PaymentStatusFilter,
} from '@/entities/payment';
import { FilterSelect, PageHeader } from '@/shared/ui';
import { PaymentsTable } from '@/widgets/payments-table';

/** 상태 필터 선택값 → 필터. 기본(결제 대기 제외)·전체·상태 하나만 받고 그 밖은 무시한다. */
const filterOf = (value: string): PaymentStatusFilter | undefined =>
  value === 'DEFAULT' || value === 'ALL'
    ? value
    : PAYMENT_STATUSES.find((status) => status === value);

/**
 * 어드민 결제 내역 — 상태 필터·페이지 상태만 소유하고 표는 위젯이 담당한다.
 * 셸(헤더 · 사이드바)은 레이아웃 라우트(app/admin-layout)가 제공한다.
 */
export const PaymentsPage = (): ReactElement => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [providerFilter, setProviderFilter] = useState<PaymentProviderFilter>('ALL');
  const [statusFilter, setStatusFilter] = useState<PaymentStatusFilter>('DEFAULT');

  return (
    <>
      <PageHeader title="결제 내역" description="고객 결제와 취소·환불 결과를 확인합니다." />

      <div className="flex flex-wrap items-center gap-2">
        <FilterSelect
          aria-label="상태 필터"
          value={statusFilter}
          onChange={(event) => {
            const next = filterOf(event.target.value);
            if (next) {
              setStatusFilter(next);
              setPage(1);
            }
          }}
        >
          <option value="DEFAULT">결제 대기 제외</option>
          <option value="ALL">전체 상태</option>
          {PAYMENT_STATUSES.map((status) => (
            <option key={status} value={status}>
              {PAYMENT_STATUS_LABELS[status].label}
            </option>
          ))}
        </FilterSelect>
        <FilterSelect
          aria-label="결제 수단 필터"
          value={providerFilter}
          onChange={(event) => {
            const value = event.target.value;
            if (value === 'ALL' || value === 'TOSS' || value === 'BANK_TRANSFER') {
              setProviderFilter(value);
              setPage(1);
            }
          }}
        >
          <option value="ALL">전체 결제 수단</option>
          <option value="TOSS">카드·간편결제</option>
          <option value="BANK_TRANSFER">계좌이체</option>
        </FilterSelect>
      </div>

      <PaymentsTable
        page={page}
        statusFilter={statusFilter}
        providerFilter={providerFilter}
        onPageChange={setPage}
        onOpen={(paymentId) => {
          void navigate(`/payments/${paymentId}`);
        }}
      />
    </>
  );
};
